<template>
    <div class="container">
        <Title :text="paziente.nome + ' ' + paziente.cognome" :backArrow="true" backVue="dashboard" />
        <b-list-group class="body">
            <span>Certificazioni</span>
            <div class="list">
                <b-list-group-item v-if="!certificazioni.length" variant="secondary"><span>Non ci sono certificazioni per questo paziente.</span></b-list-group-item>
                <b-list-group-item button v-for="documento in certificazioni" :key="documento.nome">
                    <b-row>
                        <b-col class="list-item-left"><span> {{documento.nome}} </span></b-col>
                        <b-col class="list-item-center"><span><small>Data certificazione: </small> {{format_date(documento.data_certificazione)}}</span></b-col>
                        <b-col class="list-item-right">
                            <span :class="[documento.scheda_tecnica ? 'si-scheda-tecnica' : 'no-scheda-tecnica', 'scheda-tecnica']" @click="openModal(documento, documento.scheda_tecnica)">S</span>
                            <img src="@/assets/document.svg" class="doc-img" @click="openModal(documento, true)" />
                        </b-col>
                    </b-row>
                </b-list-group-item>             
            </div>
        </b-list-group>
        <!-- Modal -->
        <b-modal id="modal" size="xl" :hide-header="true" :hide-footer="true">
            <CertificazioneDetails :certificazione="certificazione" :paziente="paziente" @closeModal="$bvModal.hide('modal');" />
        </b-modal>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'
import CertificazioneDetails from '@/components/Certificazione-Details.vue'
import {mixins} from '@/mixins'

export default {
    name: "Paziente",
    data() {
        return{
            id_paziente: this.$route.params.id,
            pdf: null,
            paziente:{
                nome: String,
                cognome: String
            },
            certificazione: Object,
            certificazioni: Array,
        }
    },
    mixins: [mixins],
    components:{
        Title,
        CertificazioneDetails
    },
    mounted(){
        this.paziente = this.$store.getters['getPaziente'];
        this.$axios
        .get(this.$apibase + '/api/pratica/get_certificazioni_by_paziente/', {
            headers:{
                Authorization:"JWT " + localStorage.getItem('access_token')
            },
            params: {
                paziente: this.id_paziente
            }
        })
        .then(response => {
            let certs = response.data;
            certs.sort((a, b) => (Date.parse(b.data_certificazione) - Date.parse(a.data_certificazione)));
            this.certificazioni = certs;
        })
        .catch((e) => {
            if (e.response.status == 403)
                this.logout();
            else
                alert(e.response);
        })

    },
    methods: {
        openModal(certificazione, canOpen){
            if(canOpen){
                this.certificazione = certificazione;
                this.$bvModal.show('modal');
            }
        }

    }
}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
    }
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
    }
    .body {
        padding-top: 35px;
        text-align: left;
    }
    .list{
        padding-top:40px;
    }
    .list-item-right{
        text-align: right;
    }
    .list-item-center{
        text-align: center;
    }
    .list-item-left{
        text-align: left;
    }
    .doc-img{
        width: 20px;
        margin-left: 20px;
    }
    .scheda-tecnica {
        font-size: 20px;
        font-weight: bold;
    }
    .si-scheda-tecnica{
        color: #6abf61;
    }
    .no-scheda-tecnica{
        color: #c6c6c6;
    }
</style>